import { EmployeeInfoCardsWidget } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX } from "react";
import Skeleton from "react-loading-skeleton";
import { useEmployeeDetailMain } from "../hooks/useEmployeeDetailMain";

export const EmployeeDetailMain = (): JSX.Element | null => {
    const vm = useEmployeeDetailMain();

    if (!vm) return null;

    if (vm.isInitialLoading) {
        return (
            <section className={"p-employee-detail__content__main"}>
                <Skeleton
                    height={"50rem"}
                    borderRadius={"1.5rem"}
                    style={{ margin: 0 }}
                    count={1}
                />
                <div style={{ padding: "3rem" }}>
                    <Skeleton
                        count={7}
                        height={"7rem"}
                        borderRadius={"1.5rem"}
                    />
                </div>
            </section>
        );
    }

    return (
        <section className={"p-employee-detail__content__main"}>
            <EmployeeInfoCardsWidget
                header={vm.widgetHeader}
                items={vm.items}
                infoCardData={vm.infoCardData}
            />

            {vm.isSecondaryFetching && (
                <div style={{ padding: "3rem" }}>
                    <Skeleton
                        count={7}
                        height={"7rem"}
                        borderRadius={"1.5rem"}
                    />
                </div>
            )}
        </section>
    );
};
